import {JacksonType, JsonIdentityInfo, JsonSubType} from "@sonner/jackson-service-v2";
import {Solicitacao} from "./solicitacao";

@JacksonType("SolicitacaoComJustificativa")
@JsonSubType({key: 'br.com.sonner.iss.entity.SolicitacaoComJustificativa', type: 'Solicitacao'})
@JsonIdentityInfo()
export class SolicitacaoComJustificativa extends Solicitacao {

  justificativa: string;
}
